import React from 'react';

import { useQueryClient } from '@tanstack/react-query';
import produce from 'immer';

import { REVIEW_TEXTS } from 'constants/ProjectConstants';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import ReviewsPendingOnMeAGGrid from './ReviewsPendingOnMeAGGrid';
import { useReviewFormsList } from './hooks/dataHooks';

const ReviewsPendingOnMe = ({ selectedTableRef, selectedTableId, selectedReviewCycleId }) => {
  const { data: reviewsListData, isLoading } = useReviewFormsList({
    reviewCycleId: selectedReviewCycleId,
    sectionId: selectedTableId,
    reactQueryKey: REACT_QUERY_KEYS.reviewsLanding.pendingOnMe,
  });
  const queryClient = useQueryClient();

  const tableDataColumns = reviewsListData?.data?.columns ?? [];
  const tableDataValues = reviewsListData?.data?.values ?? [];

  const updatePeerStatus = (reviewId, employeeId) => {
    queryClient.setQueryData(
      [REACT_QUERY_KEYS.reviewsLanding.pendingOnMe, selectedTableId, selectedReviewCycleId],
      (prev) => {
        const targetValueIndex = prev.data.values.findIndex((r) => {
          if (
            r['1'].reviewItem.review.feedbackForm.id === reviewId &&
            r['1'].reviewItem.review.receiverEmployeeId === employeeId
          ) {
            return true;
          }
          return false;
        });

        if (targetValueIndex < 0) {
          return prev;
        }

        const newData = produce(prev, (draft) => {
          draft.data.values[targetValueIndex]['1'].reviewItem.review.peerStatus = null;
        });
        return newData;
      }
    );
  };

  const resetData = () => {
    queryClient.invalidateQueries({
      queryKey: [REACT_QUERY_KEYS.reviewsLanding.pendingOnMe, selectedTableId, selectedReviewCycleId],
    });
  };

  return (
    <ReviewsPendingOnMeAGGrid
      selectedTableRef={selectedTableRef}
      columns={tableDataColumns}
      rows={tableDataValues}
      updatePeerStatus={updatePeerStatus}
      resetData={resetData}
      selectedTableId={selectedTableId}
      loading={isLoading}
      errorMessage={REVIEW_TEXTS.LANDING_PAGE_REVIEWS_TO_COMPLETE.ERROR_MSG}
    />
  );
};

export default ReviewsPendingOnMe;
